/**
 * Is this menu row the page you are on?
 *
 * A row matches either exactly, or as a prefix — a master's row has to stay lit
 * on `/football/masters/group_stage/new` and on each record underneath it, not
 * just on the listing.
 *
 * The prefix has to respect path segments, which a bare `startsWith` does not.
 * Football is the first sport with one level whose code is a prefix of another's,
 * and it showed immediately: opening **Group stage** lit **Group** as well,
 * because
 *
 *     "/football/masters/group_stage".startsWith("/football/masters/group")
 *
 * is true. Two rows highlighted, and nothing said which page you were actually
 * on. So a prefix matches only at a `/` boundary: `/masters/group` covers
 * `/masters/group/new` and never `/masters/group_stage`.
 *
 * Its own module so it can be tested without rendering the menu — the bug was in
 * one boolean, and one boolean is exactly what a test should be able to reach.
 */
export function isCurrent(
  pathname: string,
  href: string,
  match?: "exact" | "prefix",
): boolean {
  // A query string is a filter on a page, not a different page.
  const path = href.split("?")[0];
  if (match !== "prefix") return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
}
